import React from 'react';
import PropTypes from 'prop-types';

import Typography from 'components/atoms/Typography';
import SelectV2 from 'components/atoms/Select';

import { Wrapper } from './styled';

const ModalConfigContent = ({
  restaurants = [],
  companies = [],
  selectedRestaurant,
  selectedCompany,
  onSelect,
  companiesHasNextPage = false,
  onLoadMoreCompanies,
  isLoadingMoreCompanies = false,
  restaurantsHasNextPage = false,
  onLoadMoreRestaurants,
  isLoadingMoreRestaurants = false,
}) => {
  return (
    <Wrapper>
      <Typography variant='title' mb={12}>
        Società
      </Typography>
      <Typography>
        Scegli la società tra quelle che hai creato nella sezione Profilo.
      </Typography>
      <SelectV2
        onChange={onSelect}
        name='company'
        label='Seleziona la società'
        items={companies}
        selectedKey={selectedCompany}
        defaultLabel='Seleziona la società'
        hasNextPage={companiesHasNextPage}
        onLoadMore={onLoadMoreCompanies}
        isLoadingMore={isLoadingMoreCompanies}
      />
      <Typography variant='title' mb={12}>
        Insegna
      </Typography>
      <Typography>
        Scegli l’insegna tra quelle che hai creato nella sezione Profilo.
      </Typography>
      <SelectV2
        onChange={onSelect}
        name='restaurant'
        label='Seleziona l’insegna'
        items={restaurants}
        selectedKey={selectedRestaurant}
        defaultLabel='Seleziona l’insegna'
        hasNextPage={restaurantsHasNextPage}
        onLoadMore={onLoadMoreRestaurants}
        isLoadingMore={isLoadingMoreRestaurants}
      />
    </Wrapper>
  );
};

ModalConfigContent.propTypes = {
  restaurants: PropTypes.array,
  companies: PropTypes.array,
  onSelect: PropTypes.func,
  selectedRestaurant: PropTypes.any,
  selectedCompany: PropTypes.any,
  companiesHasNextPage: PropTypes.bool,
  onLoadMoreCompanies: PropTypes.func,
  isLoadingMoreCompanies: PropTypes.bool,
  restaurantsHasNextPage: PropTypes.bool,
  onLoadMoreRestaurants: PropTypes.func,
  isLoadingMoreRestaurants: PropTypes.bool,
};

export default ModalConfigContent;
